// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "@layouts/VerticalLayout";

// ** Menu Items Array
import navigation from "@src/navigation/vertical";

const VerticalLayout = (props) => {
	let userRes = JSON.parse(localStorage.getItem("UserRes"));

	// const userType = localStorage.getItem("userType");
	// const [menuData, setMenuData] = useState([])
	//const finalRoute = userRes?.PROFILE_ID !== "HORPT" ? navigation?.horptRoutes : navigation?.mainRoutes;
	const finalRoute =
		userRes?.PROFILE_ID !== "HORPT" && userRes?.PROFILE_ID === "HOADM"
			? navigation?.hoadmRoutes
			: userRes?.PROFILE_ID !== "HORPT"
			? navigation?.horptRoutes
			: navigation?.mainRoutes;
	// ** For ServerSide navigation
	// useEffect(() => {
	//   axios.get(URL).then(response => setMenuData(response.data))
	// }, [])

	return (
		<Layout menuData={finalRoute} {...props}>
			{props.children}
		</Layout>
	);
};

export default VerticalLayout;
